
        var result = require("!!../../../../node_modules/css-loader/index.js!./reported-sellers.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/reported-sellers/reported-sellers.component.css
// module id = 730
// module chunks = 0